/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.unspecced.getTaggedSuggestions'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  suggestions: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Suggestion>((() => suggestion) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get a list of suggestions (feeds and users) tagged with categories */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Suggestion = {
  $type?: 'app.bsky.unspecced.getTaggedSuggestions#suggestion'
  tag: string
  subjectType: 'actor' | 'feed' | l.UnknownString
  subject: l.UriString
}

export type { Suggestion }

const suggestion = /*#__PURE__*/ l.typedObject<Suggestion>(
  $nsid,
  'suggestion',
  /*#__PURE__*/ l.object({
    tag: /*#__PURE__*/ l.string(),
    subjectType: /*#__PURE__*/ l.string<{ knownValues: ['actor', 'feed'] }>(),
    subject: /*#__PURE__*/ l.string({ format: 'uri' }),
  }),
)

export { suggestion }
